import { Fragment } from "react";
import Routes from "../routes/routes";

const Layout = () => {
  return (
    <Fragment>
      <Routes />
    </Fragment>
  );
};

export default Layout;
